module.exports = __webpack_public_path__ + "static/img/8.b79b7b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/zh/8.png
// module id = GVY6
// module chunks = 0